import React from "react";

import { IAccommodationRoomTypeParams } from "Bands/types";
import { FormBuilder } from "shared/components";
import { IAPIError, IFormButtons } from "shared/types";

import { getFields } from "./formData";

interface Props {
  isSubmitting?: boolean;
  error?: string | boolean;
  defaultValues?: IAccommodationRoomTypeParams;
  buttons?: IFormButtons;
  apiError?: IAPIError | null;
  handleSubmit: (data: any) => void;
  globalInfo?: string;
  minimumQuantity: number;
  minimumPeoplePerRoom: number;
}

export const AccommodationRoomForm: React.FC<Props> = ({
  buttons,
  handleSubmit,
  error,
  defaultValues: defaultValuesProps,
  isSubmitting,
  apiError,
  globalInfo,
  minimumQuantity,
  minimumPeoplePerRoom,
}) => {
  const defaultValues: IAccommodationRoomTypeParams = {
    quantity: 1,
    peoplePerRoom: 1,
  };

  return (
    <FormBuilder
      isSubmitting={isSubmitting}
      apiErrorMessage={error}
      apiError={apiError}
      fields={getFields({ minimumQuantity, minimumPeoplePerRoom })}
      onSubmit={handleSubmit}
      defaultValues={defaultValuesProps || defaultValues}
      submitMode="isDirty"
      buttons={buttons}
      globalInfo={globalInfo}
      style={{ gridTemplateColumns: "repeat(6, 1fr)" }}
    />
  );
};
